import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_CHAUFFEUR_V3, UPDATE_CHAUFFEUR_V3_SUCCESS, UPDATE_CHAUFFEUR_V3_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateChauffeurV3({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/chauffeur/${payload?.data?.chauffeurId}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_CHAUFFEUR_V3_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_CHAUFFEUR_V3_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CHAUFFEUR_V3_ERROR, payload: error });
  }
}

export function* watchupdateChauffeurV3() {
  yield takeEvery(UPDATE_CHAUFFEUR_V3, updateChauffeurV3);
}

function* updateChauffeurV3Saga() {
  yield all([fork(watchupdateChauffeurV3)]);
}

export default updateChauffeurV3Saga;
